import getHiddenFieldsRecursively from '../../utils/getHiddenFieldsRecursively';
import gsap from 'gsap';

export const DURATION_SEC = 0.5;
export const DURATION_MS = DURATION_SEC * 1000;

const updateHiddenFieldsOnDOM = (
  stateRef,
  fields,
  values,
  rules,
  config,
  forceHidden = [],
  finishedAnimatingCallback = () => {}
) => {
  const { hidden: nextHidden } = getHiddenFieldsRecursively({
    fields,
    rules,
    values,
    config
  });
  const { hiddenFields: prevHidden } = stateRef.current;
  // diff the newly hidden and shown fields so we can show and hide with precision
  const newlyHidden = nextHidden.filter(h => !prevHidden.includes(h));
  const newlyShown = prevHidden.filter(h => !nextHidden.includes(h));

  stateRef.current.hiddenFields = nextHidden; // update the hidden fields for next time

  newlyHidden.forEach(id => {
    let queryMatches = document.querySelector(`[field-id=${id}]`);
    gsap.to(`[field-id=${id}]`, {
      duration: DURATION_SEC,
      height: 0,
      autoAlpha: 0,
      display: 'none'
    });
    if (queryMatches && queryMatches.classList) {
      queryMatches.classList.add('hiddenByLogic');
    }
  });

  newlyShown.forEach(id => {
    let queryMatches = document.querySelector(`[field-id=${id}]`);
    if (queryMatches && queryMatches.classList) {
      queryMatches.classList.remove('hiddenByLogic');
    }

    if (forceHidden.includes(id)) {
      return;
    }
    gsap.set(`[field-id=${id}]`, { height: 'auto', display: 'block' });

    gsap.fromTo(
      `[field-id=${id}]`,
      {
        height: 0,
        autoAlpha: 0
      },
      {
        duration: DURATION_SEC,
        height: 'auto',
        autoAlpha: 1
      }
    );
  });

  setTimeout(() => {
    finishedAnimatingCallback();
  }, DURATION_MS);
};

export const initHiddenFieldsOnDOM = (
  stateRef,
  fields,
  values,
  rules,
  config
) => {
  const { hidden } = getHiddenFieldsRecursively({
    fields,
    rules,
    values,
    config
  });

  document.querySelectorAll('[field-id]').forEach(euf => {
    const id = euf.getAttribute('field-id');

    if (!hidden.includes(id)) {
      euf.style.display = 'block';
    } else {
      if (euf && euf.classList) {
        euf.classList.add('hiddenByLogic');
      }
    }
  });

  stateRef.current.hiddenFields = hidden; // update the hidden fields for next time
};

export default updateHiddenFieldsOnDOM;
